import React from "react";
import { Col, Layout, message, Row, Select, Icon } from "antd";
import MiCompAPI from "../../util/api";
import ReportTableWrapper from "../elements/ReportTableWrapper";
import ExportJsonExcel from "js-export-excel";
const { Content } = Layout;
const { Option } = Select;
class CommissionReport extends React.Component {
  //   columns = [
  //     {
  //       title: "Invoice No",
  //       dataIndex: "inv_id",
  //       sorter: (a, b) => a.inv_id.localeCompare(b.inv_id),
  //       sortDirections: ["descend", "ascend"],
  //     },
  //     {
  //       title: "Carrier",
  //       dataIndex: "client_name",
  //       sorter: (a, b) => a.client_name.localeCompare(b.client_name),
  //       sortDirections: ["descend", "ascend"],
  //     },
  //     {
  //       title: "PlanID",
  //       dataIndex: "plan_id",
  //       render: (text, record) =>
  //         record["plan_id"] !== null && record["plan_id"] !== ""
  //           ? record["plan_id"]
  //           : "none",
  //     },
  //     {
  //       title: "Plan Name",
  //       dataIndex: "plan_Name",
  //       sorter: (a, b) => a.plan_Name.localeCompare(b.plan_Name),
  //       sortDirections: ["descend", "ascend"],
  //     },
  //     {
  //       title: "Incentive Type	",
  //       dataIndex: "incentive_Type",
  //       sorter: (a, b) => a.incentive_Type.localeCompare(b.incentive_Type),
  //       sortDirections: ["descend", "ascend"],
  //     },
  //     {
  //       title: "Total Amount",
  //       dataIndex: "total_Amount",
  //       align: "right",
  //       render: (text, record) => "$" + record["total_Amount"],
  //       sorter: (a, b) => a.total_Amount - b.total_Amount,
  //       sortDirections: ["descend", "ascend"],
  //     },
  //     {
  //       title: "Tax Amount",
  //       dataIndex: "tax_amt",
  //       align: "right",
  //       render: (text, record) => "$" + record["tax_amt"],
  //       sorter: (a, b) => a.tax_amt - b.tax_amt,
  //       sortDirections: ["descend", "ascend"],
  //     },
  //     {
  //       title: "Net Amount",
  //       dataIndex: "net_amt",
  //       align: "right",
  //       render: (text, record) => "$" + record["net_amt"],
  //       sorter: (a, b) => a.net_amt - b.net_amt,
  //       sortDirections: ["descend", "ascend"],
  //     },
  //   ];
  //   constructor(props) {
  //     super(props);
  //     this.state = {
  //       agencies: null,
  //       salesCommession: null,
  //       isLoading: false,
  //       brokers: null,
  //       months: null,
  //       years: null,
  //       year: new Date().getFullYear(),
  //       month: new Date().getMonth() + 1,
  //       user_id: 0,
  //     };
  //     this.tableButtons = [
  //       {
  //         buttonType: "primary",
  //         content: "Export Excel",
  //         clickHandler: () => {
  //           this.downloadExcel();
  //         },
  //       },
  //     ];
  //     this.api = new MiCompAPI(this.props.userPermandMasters);
  //   }
  //   downloadExcel = () => {
  //     const data = this.state.salesCommession.summary
  //       ? this.state.salesCommession.summary
  //       : ""; //tabular data
  //     var option = {};
  //     let dataTable = [];
  //     if (data) {
  //       for (let i in data) {
  //         if (data) {
  //           let obj = {
  //             "Invoice No": data[i].inv_id,
  //             Carrier: data[i].client_name,
  //             PlanID: data[i].plan_id,
  //             "Plan Name": data[i].plan_Name,
  //             "Incentive Type": data[i].incentive_Type,
  //             "Total Amount": "$" + data[i].total_Amount,
  //             "Tax Amount": "$" + data[i].tax_amt,
  //             "Net Amount": "$" + data[i].net_amt,
  //           };
  //           dataTable.push(obj);
  //         }
  //       }
  //     }
  //     option.fileName = "CommissionReport";
  //     option.datas = [
  //       {
  //         sheetData: dataTable,
  //         sheetName: "sheet",
  //         sheetFilter: [
  //           "Invoice No",
  //           "Carrier",
  //           "PlanID",
  //           "Plan Name",
  //           "Incentive Type",
  //           "Total Amount",
  //           "Tax Amount",
  //           "Net Amount",
  //         ],
  //         sheetHeader: [
  //           "Invoice No",
  //           "Carrier",
  //           "PlanID",
  //           "Plan Name",
  //           "Incentive Type",
  //           "Total Amount",
  //           "Tax Amount",
  //           "Net Amount",
  //         ],
  //       },
  //     ];
  //     if (dataTable.length > 0) {
  //       var toExcel = new ExportJsonExcel(option);
  //       toExcel.saveExcel();
  //     }
  //   };
  //   componentDidMount = () => {
  //     this.getClientMasters();
  //   };
  //   onChange = (type, e) => {
  //     if (type === "user") {
  //       this.setState({
  //         user_id: e,
  //       });
  //     }
  //     if (type === "month") {
  //       this.setState({
  //         month: e,
  //       });
  //     }
  //     if (type === "year") {
  //       this.setState({
  //         year: e,
  //       });
  //     }
  //     setTimeout(() => {
  //       if (this.state.user_id && this.state.month && this.state.year) {
  //         this.GetSalesCommission(
  //           this.state.user_id,
  //           this.state.month,
  //           this.state.year
  //         );
  //       }
  //       if (this.props.type === "bsu" && this.state.month && this.state.year) {
  //         this.GetSalesCommission(0, this.state.month, this.state.year);
  //       }
  //     }, 100);
  //   };
  //   GetSalesCommission(id, month, year) {
  //     this.setState({
  //       isLoading: true,
  //     });
  //     this.api.invoke(
  //       "GetSalesCommission/" +
  //         id +
  //         "/" +
  //         this.props.user_Type +
  //         "/" +
  //         month +
  //         "/" +
  //         year,
  //       "get",
  //       (data, success) => {
  //         if (success) {
  //           if (data.statusCode === 200) {
  //             this.setState({
  //               isLoading: false,
  //               salesCommession: data.data,
  //             });
  //           } else {
  //             message.destroy();
  //             message.error(data.statusMessage, 3);
  //           }
  //         }
  //         this.setState({
  //           isLoading: false,
  //         });
  //       }
  //     );
  //   }
  //   getClientMasters() {
  //     this.api.invoke(
  //       "GetMasters",
  //       "post",
  //       (data, success) => {
  //         if (success) {
  //           this.setState({
  //             agencies: data.agencies,
  //             brokers: data.brokers,
  //             months: data.months,
  //             years: data.years,
  //           });
  //           if (this.props.type !== "bsu") {
  //             if (this.props.user_Type === "B") {
  //               this.setState({
  //                 user_id: data.brokers[0] ? data.brokers[0].id : null,
  //               });
  //               if (data.brokers[0])
  //                 this.GetSalesCommission(
  //                   data.brokers[0] ? data.brokers[0].id : null,
  //                   this.state.month,
  //                   this.state.year
  //                 );
  //             } else {
  //               this.setState({
  //                 user_id: data.agencies[0] ? data.agencies[0].id : null,
  //               });
  //               if (data.agencies[0])
  //                 this.GetSalesCommission(
  //                   data.agencies[0].id,
  //                   this.state.month,
  //                   this.state.year
  //                 );
  //             }
  //           } else {
  //             this.setState({
  //               user_id: 0,
  //             });
  //             this.GetSalesCommission(0, this.state.month, this.state.year);
  //           }
  //         }
  //       },
  //       ["AGENCY", "ADMINBROKER", "MTH", "YR"]
  //     );
  //   }
  constructor(props) {
    super(props);

    this.api = new MiCompAPI(this.props.userPermandMasters);
  }
  render() {
    const { decodedToken } = this.props.userPermandMasters;
    // var role = decodedToken.UserRoleName;
    // var { address } = this.state.salesCommession
    //   ? this.state.salesCommession
    //   : "";
    // const { title, user_Type } = this.props;
    var role = decodedToken.UserRoleName;
    var userdId = decodedToken.UserId;
    // return (
    //   <Content>
    //     <div className="mi_main_div">
    //       <Row style={{ padding: "20px", background: "white" }}>
    //         <Col span={24}>
    //           <p
    //             className="mi_table_title"
    //             style={{ textAlign: "center", marginBottom: "60px" }}
    //           >
    //             {" "}
    //             {title}{" "}
    //           </p>
    //         </Col>
    //         <Col span={24} style={{ marginBottom: "40px" }}>
    //           <Row span={24}>
    //             {role !== "broker" && role !== "agency" ? (
    //               user_Type === "A" ? (
    //                 this.state.agencies ? (
    //                   <Col span={12} style={{ padding: "0px 20px 0px 0px" }}>
    //                     <h3>
    //                       <b>Agency : </b>
    //                     </h3>
    //                     <Select
    //                       suffixIcon={
    //                         <Icon
    //                           style={{ transform: "rotate(90deg)" }}
    //                           type="double-right"
    //                         />
    //                       }
    //                       className="mi_input_profile"
    //                       onChange={this.onChange.bind(this, "user")}
    //                       placeholder="Please Select"
    //                       showSearch={true}
    //                       optionFilterProp="children"
    //                       filterOption={(input, option) =>
    //                         option.props.children
    //                           .toLowerCase()
    //                           .indexOf(input.toLowerCase()) >= 0
    //                       }
    //                       defaultValue={
    //                         this.state.agencies[0]
    //                           ? this.state.agencies[0].id
    //                           : undefined
    //                       }
    //                     >
    //                       {this.state.agencies
    //                         ? this.state.agencies.map((tag) => (
    //                             <Option value={tag.id} key={tag.id}>
    //                               {tag.name}
    //                             </Option>
    //                           ))
    //                         : ""}
    //                     </Select>
    //                   </Col>
    //                 ) : (
    //                   ""
    //                 )
    //               ) : this.state.brokers ? (
    //                 <Col span={12} style={{ padding: "0px 20px 0px 0px" }}>
    //                   <h3>
    //                     <b>Broker : </b>
    //                   </h3>
    //                   <Select
    //                     suffixIcon={
    //                       <Icon
    //                         style={{ transform: "rotate(90deg)" }}
    //                         type="double-right"
    //                       />
    //                     }
    //                     className="mi_input_profile"
    //                     onChange={this.onChange.bind(this, "user")}
    //                     placeholder="Please Select"
    //                     showSearch={true}
    //                     optionFilterProp="children"
    //                     filterOption={(input, option) =>
    //                       option.props.children
    //                         .toLowerCase()
    //                         .indexOf(input.toLowerCase()) >= 0
    //                     }
    //                     defaultValue={
    //                       this.state.brokers[0]
    //                         ? this.state.brokers[0].id
    //                         : undefined
    //                     }
    //                   >
    //                     {this.state.brokers
    //                       ? this.state.brokers.map((tag) => (
    //                           <Option value={tag.id} key={tag.id}>
    //                             {tag.name}
    //                           </Option>
    //                         ))
    //                       : ""}
    //                   </Select>
    //                 </Col>
    //               ) : (
    //                 ""
    //               )
    //             ) : (
    //               ""
    //             )}
    //             <Col
    //               span={this.props.type === "bsu" ? 12 : 8}
    //               style={{ padding: "0px 20px" }}
    //             >
    //               <h3>
    //                 <b>Month : </b>
    //               </h3>
    //               <Select
    //                 suffixIcon={
    //                   <Icon
    //                     style={{ transform: "rotate(90deg)" }}
    //                     type="double-right"
    //                   />
    //                 }
    //                 className="mi_input_profile"
    //                 onChange={this.onChange.bind(this, "month")}
    //                 placeholder="Please Select"
    //                 showSearch={true}
    //                 optionFilterProp="children"
    //                 filterOption={(input, option) =>
    //                   option.props.children
    //                     .toLowerCase()
    //                     .indexOf(input.toLowerCase()) >= 0
    //                 }
    //                 defaultValue={
    //                   this.state.month ? this.state.month : undefined
    //                 }
    //               >
    //                 {this.state.months
    //                   ? this.state.months.map((tag) => (
    //                       <Option value={tag.id} key={tag.id}>
    //                         {tag.name}
    //                       </Option>
    //                     ))
    //                   : ""}
    //               </Select>
    //             </Col>
    //             <Col
    //               span={this.props.type === "bsu" ? 12 : 8}
    //               style={{ padding: "0px 20px 0px 0px" }}
    //             >
    //               <h3>
    //                 <b>Years : </b>
    //               </h3>
    //               <Select
    //                 suffixIcon={
    //                   <Icon
    //                     style={{ transform: "rotate(90deg)" }}
    //                     type="double-right"
    //                   />
    //                 }
    //                 className="mi_input_profile"
    //                 onChange={this.onChange.bind(this, "year")}
    //                 placeholder="Please Select"
    //                 showSearch={true}
    //                 optionFilterProp="children"
    //                 filterOption={(input, option) =>
    //                   option.props.children
    //                     .toLowerCase()
    //                     .indexOf(input.toLowerCase()) >= 0
    //                 }
    //                 defaultValue={this.state.year ? this.state.year : undefined}
    //               >
    //                 {this.state.years
    //                   ? this.state.years.map((tag) => (
    //                       <Option value={tag.id} key={tag.id}>
    //                         {tag.name}
    //                       </Option>
    //                     ))
    //                   : ""}
    //               </Select>
    //             </Col>
    //             <Col span={24}>
    //               <Row
    //                 style={{
    //                   width: "300px",
    //                   float: "right",
    //                   marginTop: "50px",
    //                 }}
    //               >
    //                 <Col span={24}>
    //                   <h4>
    //                     <b>Billing Address :</b>{" "}
    //                     {address
    //                       ? address.name +
    //                         ", " +
    //                         address.street +
    //                         ", " +
    //                         address.city +
    //                         ", " +
    //                         address.statename
    //                           .split(" ")
    //                           .map(
    //                             (w) =>
    //                               w[0].toUpperCase() + w.substr(1).toLowerCase()
    //                           )
    //                           .join(" ") +
    //                         ", " +
    //                         address.zipcode.substring(0, 5) +
    //                         "-" +
    //                         address.zipcode.substring(5, 9)
    //                       : "None"}
    //                     <br></br>
    //                     Phone Number :{" "}
    //                     {address && address.phone_Number.length === 10 ? (
    //                       <a href={"tel:+" + address.phone_Number}>
    //                         {"(" +
    //                           address.phone_Number.substring(0, 3) +
    //                           ") " +
    //                           address.phone_Number.substring(3, 6) +
    //                           "-" +
    //                           address.phone_Number.substring(6)}
    //                       </a>
    //                     ) : (
    //                       "Invalid US Number"
    //                     )}
    //                     <br></br>
    //                     Email :{" "}
    //                     {address && address.email ? address.email : "None"}{" "}
    //                   </h4>
    //                 </Col>
    //               </Row>
    //             </Col>
    //           </Row>
    //         </Col>
    //         <Col span={24}>
    //           <Row style={{ width: "300px", float: "right" }}>
    //             <Col span={24}>
    //               <Row span={24}>
    //                 <Col span={12} className="footertext">
    //                   Payable Amount:{" "}
    //                 </Col>
    //                 <Col span={12} className="footertext">
    //                   {this.state.salesCommession
    //                     ? "$" + this.state.salesCommession.total_pay_amount
    //                     : "$0"}
    //                 </Col>
    //               </Row>
    //             </Col>
    //           </Row>
    //         </Col>
    //         <Col span={24}>
    //           <ReportTableWrapper
    //             rowKey="plan_id"
    //             columns={this.columns}
    //             data={
    //               this.state.salesCommession
    //                 ? this.state.salesCommession.summary
    //                 : null
    //             }
    //             loading={this.state.isLoading}
    //             buttons={this.tableButtons}
    //             search={true}
    //           />
    //         </Col>
    //         <Col span={24}>
    //           <Row
    //             style={{ width: "300px", float: "right", marginTop: "20px" }}
    //           >
    //             <Col span={24}>
    //               <Row span={24}>
    //                 <Col span={12} className="footertext">
    //                   Total Amount:{" "}
    //                 </Col>
    //                 <Col span={12} className="footertext">
    //                   {this.state.salesCommession
    //                     ? "$" + this.state.salesCommession.total_amount
    //                     : "$0"}
    //                 </Col>
    //               </Row>
    //               <Row span={24}>
    //                 <Col span={12} className="footertext">
    //                   Adjustment Amount:{" "}
    //                 </Col>
    //                 <Col span={12} className="footertext">
    //                   {this.state.salesCommession
    //                     ? "$" + this.state.salesCommession.total_adj_amount
    //                     : "$0"}
    //                 </Col>
    //               </Row>
    //               <Row span={24}>
    //                 <Col span={12} className="footertext">
    //                   Tax Amount:{" "}
    //                 </Col>
    //                 <Col span={12} className="footertext">
    //                   {this.state.salesCommession
    //                     ? "$" + this.state.salesCommession.total_Tax_amount
    //                     : "$0"}
    //                 </Col>
    //               </Row>
    //               <Row span={24}>
    //                 <Col span={12} className="footertext">
    //                   Net Amount:{" "}
    //                 </Col>
    //                 <Col span={12} className="footertext">
    //                   {this.state.salesCommession
    //                     ? "$" + this.state.salesCommession.total_Net_amount
    //                     : "$0"}
    //                 </Col>
    //               </Row>
    //             </Col>
    //           </Row>
    //         </Col>
    //       </Row>
    //     </div>
    //   </Content>
    // );
    return (
      <Content>
        <div className="mi_main_div" style={{ paddingTop: "1px" }}>
          <div
            style={{
              textAlign: "center",
              alignContent: "center",
              marginTop: "3%",
            }}
          >
            {userdId === "10297" && (
              <iframe
                title="Broker_V1(New)_CommissionData"
                width="1024"
                height="612"
                src="
             https://app.powerbi.com/view?r=eyJrIjoiZGRmY2VjZmUtZWUzOC00MWYyLTg0NmQtYTAzMzg5OWY3MDI0IiwidCI6ImZjOGM4MTM5LTk1YTktNDRiNC1hMzg0LWQ1YzBhOGExYmQxMCIsImMiOjN9"
                frameborder="0"
                allowFullScreen="true"
              ></iframe>
            )}
            {userdId === "10302" && (
              <iframe
                title="Carrier_V1(New)_CommissionData"
                width="1024"
                height="612"
                src="
              https://app.powerbi.com/view?r=eyJrIjoiNjFhZWI5NTctOWE4NC00NDNjLWExZDAtMTY0M2ZiYWQ4Njc4IiwidCI6ImZjOGM4MTM5LTk1YTktNDRiNC1hMzg0LWQ1YzBhOGExYmQxMCIsImMiOjN9"
                frameborder="0"
                allowFullScreen="true"
              ></iframe>
            )}
          </div>
          {/* </div> */}
          {/* {dashboard} */}
        </div>
      </Content>
    );
  }
}
export default CommissionReport;
